<template lang="pug">
  v-content
    v-container(fluid grid-list-md)
      v-layout(row wrap)
        v-flex(xs12)
          v-card
            v-card-title
              v-layout(row wrap)
                v-flex(xs12)
                  v-btn(@click="openAddDialog" color="primary") 新規追加

            v-card-text
              v-layout(row wrap)
                v-flex(xs12)
                  v-card
                    v-card-text
                      BillingTypeFilterConditions(@onChangeSearchConditions="onChangeSearchConditions")

            v-card-title
              BillingTypeTable(ref="BillingTypeTable" v-bind:prop-header="billingTypeTableHeader"  v-bind:prop-data="billingTypeList" detail-url="billingType/fetchBillingType" @open-detail="openDetail" :getListActionName="getListActionName" :displaySlotBody="true")
                template(v-slot:body="{ body }")
                    td.text-xs-left {{ body.billingCd }}
                    td.text-xs-left {{ body.billingTypeName }}
                    td.text-xs-left {{ getFinanceType(body.financeType) }}

    BillingTypeEditDialog(ref="BillingTypeEditDialog" :postUrl="$config.urls.postEditBillingType" :deleteUrl="$config.urls.deleteBillingType" @updated="itemUpdated" @deleted="itemUpdated")
</template>

<script>
import BillingTypeEditDialog from "@/components/management/billing-type/BillingTypeEdit";
import BillingTypeTable from "@/components/common/PagingListTable";
import BillingTypeFilterConditions from "@/components/management/billing-type/BillingTypeFilterConditions";
import { mapGetters } from "vuex";

export default {
  components: {
    BillingTypeEditDialog,
    BillingTypeTable,
    BillingTypeFilterConditions
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      getFinanceType: "site/financeTypeLabel"
    }),
    getListActionName: {
      get() {
        return "billingType/fetchAllBillingType";
      }
    },
    billingTypeList: {
      get() {
        return this.$store.state.billingType.billingTypeList;
      }
    },
    billingTypeTableHeader: {
      get() {
        return [
          { text: "請求CD", value: "billingCd", centerAlign: "" },
          { text: "名称", value: "billingTypeName", centerAlign: "" },
          { text: "会計種別", value: "financeType", centerAlign: "" }
        ];
      }
    }
  },
  mounted() {
    this.loadListData();
  },
  methods: {
    /**
     * 新規作成ダイアログの表示
     */
    openAddDialog() {
      this.$refs.BillingTypeEditDialog.openDialog();
    },
    /**
     * 詳細ダイアログの表示
     * @param item
     */
    openDetail(item) {
      this.$refs.BillingTypeEditDialog.openDialog(item);
    },
    /**
     * データの読み込み
     * @param params
     */
    loadListData() {
      this.$refs.BillingTypeTable.loadData();
    },
    /**
     * レコード追加・更新・削除時に検索同様ページ番号0にして再取得
     */
    itemUpdated(response, data) {
      this.$refs.BillingTypeTable.resetPageCount();
      this.loadListData();
    },
    /**
     * 検索条件欄に入力されたら発火
     * @param searchCond
     */
    onChangeSearchConditions(searchCond) {
      this.searchCond = searchCond;
      this.$refs.BillingTypeTable.setSearchConditions(searchCond);
      this.$refs.BillingTypeTable.resetPageCount();
      this.loadListData();
    }
  }
};
</script>
